import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AttachmentsModule } from '../attachments/attachments.module';
import { BrowserManagerDataModule } from '../browser-manager-data/browser-manager-data.module';
import { DialogModule } from '../dialog/dialog.module';
import { EntityMasterModule } from '../entity-master/entity-master.module';
import { FeaturesModule } from '../features/features.module';
import { FeedModule } from '../feed/feed.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { GeolocationModule } from '../geolocation/geolocation.module';
import { MessageDeliveryModule } from '../message-delivery/message-delivery.module';
import { PaymentsModule } from '../payments/payments.module';
import { RendererModule } from '../renderer/renderer.module';
import { SearchModule } from '../search/search.module';
import { SharedModule } from '../shared/shared.module';
import { ToasterModule } from '../toaster/toaster.module';
import { XeroModule } from '../xero/xero.module';
import { AddAdditionalFieldsComponent } from './components/add-additional-fields/add-additional-fields.component';
import { AddClientComponent } from './components/add-client/add-client.component';
import { AddDepositRequestComponent } from './components/add-deposit-request/add-deposit-request.component';
import { AddDocumentItemsComponent } from './components/add-document-items/add-document-items.component';
import { AddNoteComponent } from './components/add-note/add-note.component';
import { AddPaymentDetailsComponent } from './components/add-payment-details/add-payment-details.component';
import { AsideCreateComponent } from './components/aside-create/aside-create.component';
import { AttachmentInfoFormComponent } from './components/attachment-info-form/attachment-info-form.component';
import { AttachmentsListItemComponent } from './components/attachments-list-item/attachments-list-item.component';
import { AttachmentsListComponent } from './components/attachments-list/attachments-list.component';
import { ContentCreateComponent } from './components/content-create/content-create.component';
import { ContentSendComponent } from './components/content-send/content-send.component';
import { ConvertToInvoiceComponent } from './components/convert-to-invoice-action/convert-to-invoice-action.component';
import { ConvertToInvoiceDialogComponent } from './components/convert-to-invoice-dialog/convert-to-invoice-dialog.component';
import { CopyDocumentActionComponent } from './components/copy-document-action/copy-document-action.component';
import { CopyDocumentDialogComponent } from './components/copy-document-dialog/copy-document-dialog.component';
import { DepositRequestDialogComponent } from './components/deposit-request-dialog/deposit-request-dialog.component';
import { DocumentActionsComponent } from './components/document-actions/document-actions.component';
import { DocumentBalanceBreakdownComponent } from './components/document-balance-breakdown/document-balance-breakdown.component';
import { DocumentCreateComponent } from './components/document-create/document-create.component';
import { DocumentDiscountDialogComponent } from './components/document-discount-dialog/document-discount-dialog.component';
import { DocumentItemOptionsComponent } from './components/document-item-options/document-item-options.component';
import { DocumentItemsListItemComponent } from './components/document-items-list-item/document-items-list-item.component';
import { DocumentItemsListComponent } from './components/document-items-list/document-items-list.component';
import { DocumentNumberInfoComponent } from './components/document-number-info/document-number-info.component';
import { DocumentPaymentActionsComponent } from './components/document-payment-actions/document-payment-actions.component';
import { DocumentPaymentOptionsComponent } from './components/document-payment-options/document-payment-options.component';
import { DocumentPreviewComponent } from './components/document-preview/document-preview.component';
import { DocumentScheduleComponent } from './components/document-schedule/document-schedule.component';
import { DocumentSendComponent } from './components/document-send/document-send.component';
import { EditTaxDialogComponent } from './components/edit-tax-dialog/edit-tax-dialog.component';
import { EstimateStatusComponent } from './components/estimate-status/estimate-status.component';
import { ExpensePickerDialogComponent } from './components/expense-picker-dialog/expense-picker-dialog.component';
import { ItemPickerDialogComponent } from './components/item-picker-dialog/item-picker-dialog.component';
import { PickerDialogListItemComponent } from './components/picker-dialog-list-item/picker-dialog-list-item.component';
import { PlaceholderAsideComponent } from './components/placeholder-aside/placeholder-aside.component';
import { PrintDocumentActionComponent } from './components/print-document-dropdown-item/print-document-action.component';
import { RemindersDisabledDialogComponent } from './components/reminders-disabled-dialog/reminders-disabled-dialog.component';
import { RemoveDepositRequestDialogComponent } from './components/remove-deposit-request-dialog/remove-deposit-request-dialog.component';
import { ShippingInfoDialogComponent } from './components/shipping-info-dialog/shipping-info-dialog.component';
import { TimeEntryPickerDialogComponent } from './components/time-entry-picker-dialog/time-entry-picker-dialog.component';
import { TransactionHistoryListItemComponent } from './components/transaction-history-list-item/transaction-history-list-item.component';
import { IsDepositPipe } from './components/transaction-history-list/is-deposit.pipe';
import { TransactionHistoryListComponent } from './components/transaction-history-list/transaction-history-list.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component';
import { UpdateClientEmailDialogComponent } from './components/update-client-email-dialog/update-client-email-dialog.component';
import { UpdateDepositRequestDialogComponent } from './components/update-deposit-request-dialog/update-deposit-request-dialog.component';
import { ViewRemindersDialogComponent } from './components/view-reminders-dialog/view-reminders-dialog.component';
import { DocumentDetailComponent } from './document-detail.component';
import { MissingClientEmailDialogComponent } from './components/missing-client-email-dialog/missing-client-email-dialog.component';
import { AsideActionsComponent } from './components/aside-actions/aside-actions.component';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { VerifyAccountModule } from '../verify-account/verify-account.module';
import { SortablejsModule } from 'ngx-sortablejs';
import { DocumentDetailService } from './document-detail.service';

const internalComponents = [
  AddNoteComponent,
  AddPaymentDetailsComponent,
  AddDocumentItemsComponent,
  DocumentItemsListItemComponent,
  DocumentItemsListComponent,
  DocumentItemOptionsComponent,
  AttachmentsListComponent,
  AttachmentsListItemComponent,
  DocumentActionsComponent,
  ShippingInfoDialogComponent,
  DocumentDiscountDialogComponent,
  AttachmentInfoFormComponent,
  AddAdditionalFieldsComponent,
  TransactionHistoryListComponent,
  TransactionHistoryListItemComponent,
  DocumentPaymentOptionsComponent,
  RemindersDisabledDialogComponent,
  ViewRemindersDialogComponent,
  CopyDocumentActionComponent,
  PrintDocumentActionComponent,
  ConvertToInvoiceComponent,
  DocumentBalanceBreakdownComponent,
  DocumentNumberInfoComponent,
  DocumentPaymentActionsComponent,
  DocumentScheduleComponent,
  PlaceholderAsideComponent,
  EditTaxDialogComponent,
  EstimateStatusComponent,
  ExpensePickerDialogComponent,
  ItemPickerDialogComponent,
  DepositRequestDialogComponent,
  RemoveDepositRequestDialogComponent,
  UpdateDepositRequestDialogComponent,
  TimeEntryPickerDialogComponent,
  AddDepositRequestComponent,
  UpdateClientEmailDialogComponent,
  PickerDialogListItemComponent,
  MissingClientEmailDialogComponent,
];
const exportableComponents = [
  DocumentDetailComponent,
  AsideCreateComponent,
  DocumentCreateComponent,
  DocumentPreviewComponent,
  DocumentSendComponent,
  AsideActionsComponent,
  ContentCreateComponent,
  ContentSendComponent,
  TransactionHistoryComponent,
  CopyDocumentDialogComponent,
  AddClientComponent,
  ConvertToInvoiceDialogComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FeedModule,
    FormMasterModule,
    DialogModule,
    AttachmentsModule,
    RendererModule,
    PaymentsModule,
    ToasterModule,
    MessageDeliveryModule,
    BrowserManagerDataModule,
    FeaturesModule,
    SearchModule,
    SortablejsModule,
    EntityMasterModule,
    GeolocationModule,
    XeroModule,
    I2gNgUiModule,
    VerifyAccountModule,
  ],
  declarations: [...internalComponents, ...exportableComponents, IsDepositPipe],
  providers: [DocumentDetailService],
  exports: [...exportableComponents],
})
export class DocumentDetailModule {}
